var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.65557 12.6078L13.2821 20.2456C13.495 20.4547 13.7788 20.5742 14.0813 20.5742C14.3764 20.5705 14.664 20.4547 14.8768 20.2456L22.4062 12.705C22.4101 12.7011 22.414 12.6976 22.4177 12.6943C22.4248 12.6881 22.4312 12.6824 22.4361 12.6751C22.8656 12.2269 22.8544 11.5173 22.4062 11.084C21.9581 10.6545 21.2484 10.6657 20.8152 11.1139L15.2055 16.7311V1.99723C15.2055 1.37725 14.7013 0.873047 14.0813 0.873047C13.4576 0.873047 12.9534 1.37725 12.9534 1.99723V16.7311L7.2466 11.0168C6.80589 10.5798 6.09254 10.5761 5.65557 11.0168C5.2186 11.4575 5.21486 12.1671 5.65557 12.6078ZM27.1233 20.5481C27.1233 19.9281 26.6191 19.4239 25.9991 19.4239C25.3792 19.4239 24.875 19.9244 24.8787 20.5481V24.873H3.1271V20.5481C3.10469 19.958 2.63037 19.4874 2.044 19.465C1.42028 19.4426 0.897409 19.9281 0.875 20.5481V25.9972C0.875 26.6172 1.3792 27.1214 1.99918 27.1214H25.9991C26.6191 27.1214 27.1233 26.6172 27.1233 25.9972V20.5481Z",
    fill: "#650098"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImport);
export default __webpack_public_path__ + "static/media/icon-import.2817316ba61558c85383f28c4336ad83.svg";
export { ForwardRef as ReactComponent };